
<template>
  <!-- eslint-disable -->
  <svg :style="style" :class="classes" data-components="LogoTiktokSvg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 24"><path fill="#fff" d="M21.441 5.851c0-.105 0-.105-.12-.105-.27 0-.54-.03-.81-.075-.975-.15-4.14-1.8-4.665-4.515 0-.06-.135-.72-.135-1.02 0-.135 0-.135-.135-.135h-3.795c-.255 0-.21-.03-.21.225v16.095c0 .195 0 .405-.045.6-.18 1.035-.72 1.845-1.62 2.4-.78.48-1.62.615-2.52.435a4.666 4.666 0 01-.81-.27l-.06-.06c-.09-.075-.195-.135-.285-.21-1.14-.795-1.695-1.89-1.53-3.27.165-1.395.975-2.34 2.295-2.835.39-.15.81-.21 1.23-.18.27 0 .54.045.81.12.09.03.135 0 .15-.105v-.105c0-.96-.03-3.06-.045-3.075v-.825c0-.075-.045-.09-.105-.105a7.167 7.167 0 00-1.5-.03 7.297 7.297 0 00-2.025.435 7.737 7.737 0 00-2.745 1.725 7.453 7.453 0 00-1.605 2.295 7.42 7.42 0 00-.645 2.61c-.03.39-.015.78.015 1.185.045.54.15 1.08.315 1.59.48 1.5 1.335 2.715 2.565 3.69.12.105.24.21.39.27.06.06.12.105.195.165.195.15.405.285.63.39 1.38.675 2.82.96 4.35.765 1.98-.24 3.63-1.125 4.935-2.625 1.23-1.425 1.815-3.09 1.83-4.965.015-2.67 0-5.34 0-8.01 0-.06-.03-.15.03-.18s.105.045.165.075c.99.66 2.07 1.125 3.225 1.395.675.15 1.365.255 2.055.24.225 0 .255 0 .255-.225 0-.945-.045-3.54-.045-3.795l.015.015z"/></svg>
</template>

<script>
import globalMixin from 'Libs/mixins/globalMixin';

export default {
  name: 'LogoTiktokSvg',
  mixins: [globalMixin],
  props: {
    width: {
      type: [String, Number, Boolean],
      default: false
    },
    height: {
      type: [String, Number, Boolean],
      default: false
    },
    original: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style() {
      const style = {};

      if (this.width) {
        style.width = this.width + 'px';
      }

      if (this.height) {
        style.height = this.height + 'px';
      }

      return style;
    }
  }
};
</script>
